import React, { useState } from 'react';

export default function WizardModal({ open, onClose, onSubmit }) {
  const [currency, setCurrency] = useState('TRY');
  const [lang, setLang] = useState('TR');
  const [offerType, setOfferType] = useState('yurtiçi');

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl p-6 w-[95vw] max-w-md border border-blue-100 flex flex-col gap-4 animate-fade-in">
        <div className="text-2xl font-bold text-blue-900 text-center mb-2">Teklif Sihirbazı</div>
        <div className="flex flex-col gap-3">
          <label className="font-semibold text-blue-800">Para Birimi</label>
          <div className="flex gap-2">
            <button onClick={() => setCurrency('TRY')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${currency === 'TRY' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>₺ TRY</button>
            <button onClick={() => setCurrency('USD')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${currency === 'USD' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>$ USD</button>
            <button onClick={() => setCurrency('EUR')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${currency === 'EUR' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>€ EUR</button>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <label className="font-semibold text-blue-800">Dil</label>
          <div className="flex gap-2">
            <button onClick={() => setLang('TR')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${lang === 'TR' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>Türkçe</button>
            <button onClick={() => setLang('EN')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${lang === 'EN' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>English</button>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <label className="font-semibold text-blue-800">Teklif Tipi</label>
          <div className="flex gap-2">
            <button onClick={() => setOfferType('yurtiçi')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${offerType === 'yurtiçi' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>Yurtiçi</button>
            <button onClick={() => setOfferType('yurtdışı')} className={`px-4 py-2 rounded-lg font-semibold text-sm transition ${offerType === 'yurtdışı' ? 'bg-blue-100 text-blue-900' : 'bg-white text-blue-700 hover:bg-blue-50'}`}>Yurtdışı</button>
          </div>
        </div>
        <div className="flex gap-2 mt-4">
          <button onClick={onClose} className="flex-1 px-4 py-2 rounded-lg bg-gray-100 text-gray-600 hover:bg-gray-200 font-semibold">İptal</button>
          <button onClick={() => onSubmit({ currency, lang, offerType })} className="flex-1 px-4 py-2 rounded-lg bg-blue-700 text-white hover:bg-blue-800 font-semibold">Devam</button>
        </div>
      </div>
    </div>
  );
} 